import { Code, useMantineTheme } from '@mantine/core';

type VariableProps = React.ComponentProps<typeof Code> & {
  color: 'coral' | 'blue' | 'purple';
};

export const Variable = ({ color, ...codeProps }: VariableProps) => {
  const style = useGetCodeStyle(color);

  return <Code {...codeProps} style={style} />;
};

const useGetCodeStyle = (color: 'coral' | 'blue' | 'purple') => {
  const theme = useMantineTheme();

  switch (color) {
    case 'coral':
      return {
        border: `1px solid ${theme.colors.coral[5]}`,
        backgroundColor: theme.colors.coral[2],
        color: theme.colors.coral[7],
      };
    case 'blue':
      return {
        border: `1px solid ${theme.colors.blue[4]}`,
        backgroundColor: theme.colors.blue[1],
        color: theme.colors.blue[8],
      };
    case 'purple':
      return {
        border: `1px solid ${theme.colors.purple[4]}`,
        backgroundColor: theme.colors.purple[1],
        color: theme.colors.purple[5],
      };
    default:
      return {};
  }
};
